module.exports = __webpack_public_path__ + "static/media/16.7359ac87.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/16.png
// module id = 1389
// module chunks = 0